import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import axios from "axios";
import "./UserDetails.css";

const UserDetails = () => {
  const [userData, setUserData] = useState(null);
  /* Three states, not two. `useState({})` made the old `if (!userData)`
     unreachable - an empty object is truthy - so the page rendered its
     labels with nothing beside them until the request landed, and showed
     the same empty labels forever if it failed. */
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let live = true;

    const getUserDetails = async () => {
      try {
        const token = localStorage.getItem("userToken");
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/auth/v1/user`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!live) return;
        setUserData(response.data.data);
        setStatus("ready");
      } catch (error) {
        if (!live) return;
        console.error("Error fetching user details:", error);
        setStatus("error");
      }
    };

    getUserDetails();
    return () => {
      live = false;
    };
  }, []);

  const initial = (userData?.fullName || userData?.email || "?")
    .trim()
    .charAt(0)
    .toUpperCase();

  return (
    <>
      <Navbar />
      <div className="account-page">
        <header className="page-head">
          <div className="page-head-text">
            <h1 className="page-title">Your account</h1>
            <p className="page-sub">
              The details this plan and your team are registered under.
            </p>
          </div>
        </header>

        {status === "loading" && (
          <div className="account-card account-state">Loading your details…</div>
        )}

        {status === "error" && (
          <div className="account-card account-state">
            <p className="account-state-title">Could not load your details</p>
            <p className="account-state-text">
              The request did not come back. Reload the page to try again.
            </p>
          </div>
        )}

        {status === "ready" && (
          <div className="account-card">
            <div className="account-identity">
              {/* Derived from the name on the record. The stock cartoon
                  dentist that used to sit here was a picture of nobody -
                  an initial at least belongs to this account. */}
              <span className="account-avatar" aria-hidden="true">
                {initial}
              </span>
              <div className="account-identity-text">
                <p className="account-name">
                  {userData?.fullName || "No name on file"}
                </p>
                <p className="account-email">{userData?.email}</p>
              </div>
            </div>

            {/* The old card led with `UserID: 6a55e9e3...`, a raw Mongo
                ObjectId. It means nothing to the person reading it and is
                not something an account page needs to publish. */}
            <dl className="account-rows">
              <div>
                <dt>Full name</dt>
                <dd className={userData?.fullName ? "" : "account-empty"}>
                  {userData?.fullName || "Not set"}
                </dd>
              </div>
              <div>
                <dt>Email</dt>
                <dd className={userData?.email ? "" : "account-empty"}>
                  {userData?.email || "Not set"}
                </dd>
              </div>
            </dl>

            <div className="account-actions">
              <Link className="account-link" to="/subscription">
                View subscription
              </Link>
              <Link className="account-link" to="/myteam">
                Manage team
              </Link>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default UserDetails;
